var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "avue-crud",
        {
          ref: "crud",
          attrs: { option: _vm.option, data: _vm.list.value },
          on: { "refresh-change": _vm.refreshChange },
          scopedSlots: _vm._u([
            {
              key: "index",
              fn: function ({ row }) {
                return [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: row.cdkeyConfigId },
                      model: {
                        value: _vm.selectRow,
                        callback: function ($$v) {
                          _vm.selectRow = $$v
                        },
                        expression: "selectRow",
                      },
                    },
                    [_vm._v(" ")]
                  ),
                ]
              },
            },
            {
              key: "cdkeyConfigId",
              fn: function ({ row }) {
                return [
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#409EFF", cursor: "pointer" },
                      on: {
                        click: function ($event) {
                          return _vm.toActiveGenerate(row.cdkeyConfigId)
                        },
                      },
                    },
                    [_vm._v(_vm._s(row.cdkeyConfigId))]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "mySearch" }, [
            _c(
              "div",
              { staticClass: "search-contain" },
              [_c("Search", { on: { exportExcel: _vm.exportOrder } })],
              1
            ),
          ]),
        ],
        2
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          "current-page": _vm.searchParams.current,
          "page-size": _vm.searchParams.size,
          total: _vm.searchParams.total,
          "page-sizes": [10, 20, 30, 40, 50],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }